import Plyr from "plyr";
import "plyr/dist/plyr.css";

/**
 * Usage:
 *
 * Step 1: Somewhere in JS...
 *   import Alpine from "alpinejs";
 *   import spine from "./plyr";
 *   Alpine.data('plyr', plyr);
 *   Alpine.start();
 *
 * Step 2: Somewhere in markup...
 *   <div x-data="plyr()">
 *     <audio x-ref="media" src="path-to-file.mp3"></audio>
 *   </div>
 *
 *   Plyr config options can be passed to the component:
 *   <div x-data="plyr({ mute : true })">
 *     <audio x-ref="media" src="path-to-file.mp3"></audio>
 *   </div>
 *
 * Important: `x-data` cannot be placed directly on the media element,
 * because Plyr wraps the element around custom markup, which triggers
 * Alpine to re-bind to the element again.
 *
 * @param config
 * @returns {{init(): void, config: {}, player: null}}
 */
export default (config = {}) => ({
  config : {
    controls: [
      "play",
      "progress",
      "current-time",
      "mute",
      "volume",
    ],
    ...config
  },
  player : null,
  init() {
    if( ! this.$refs.media) {
      console.log('Media element not found');
      return;
    }
    this.player = new Plyr(this.$refs.media, this.config);
  }
});
